import React from 'react'

const CarouselLoader = () => {
    return (
        <div className='w-full bg-[#0D2436] md:w-4/5 lg:w-[550px] h-[200px] md:h-[400px] rounded-xl animate-pulse-opacity'>

        </div>
    )
}

export default CarouselLoader